import Page from '../../../components/Page/Page'
import { Venue } from '../../../components/venue/Venue'

const WhatsAppPage = () => {
  return (
    <Page pageTitle={{ title: 'WhatsApp', level: 4 }}>
      <Venue.SettingWhatsAppVenue />
    </Page>
  )
}

export default WhatsAppPage
